import styled from 'styled-components';

export default styled.div`
  color: rgb(98, 106, 146);
  line-height: 1.5;
  position: relative;
  top: -2rem;
`;
